export const CARDKNOX_IFIELDS_VERSION = "2.9.2109.2701";
export const CARDKNOX_IFIELDS_KEY =
  "ifields_cardcaincdev5da757da83174a21bfd202060";
